import { createElement, type ComponentProps } from 'react'

import crmStyles from './index.css?inline'

import { App } from './app/App'

const CRM_STYLES_ELEMENT_ID = 'smetter-crm-styles'

// Временная изоляция CRM-стилей: держим Tailwind utilities вне общего legacy main.css,
// чтобы они не конфликтовали с Bootstrap на страницах вне CRM.
// Целевая задача: вынести CRM в отдельный Vite entrypoint и подключать ее crm.js/crm.css
// только в CRM layout, после чего удалить inline-инъекцию стилей.

// Суть задачи:

//   - сделать отдельный Vite entry для CRM, например front/src/crm-entry.tsx;
//   - собирать отдельные артефакты: crm.js, crm.css;
//   - подключать crm.css/js только в CRM Twig layout;
//   - legacy React оставить на текущем bundle.js/main.css;
//   - включить нормальный cssCodeSplit, если получится уйти от single IIFE/lib-сборки;
//   - удалить ?inline-инъекцию после разделения.
const ensureCrmStyles = () => {
  if (typeof document === 'undefined' || document.getElementById(CRM_STYLES_ELEMENT_ID)) {
    return
  }

  const style = document.createElement('style')
  style.id = CRM_STYLES_ELEMENT_ID
  style.textContent = crmStyles
  document.head.appendChild(style)
}

export const CrmApp = (props: ComponentProps<typeof App>) => {
  ensureCrmStyles()

  return createElement(App, props)
}
